<template>
  <q-form @submit="onSubmit">
    <q-card flat>
      <q-card-section>
        <q-input dir="ltr" filled v-model="recordInfo.Cs_SendLinkDateTime" mask="date" :rules="['date']"
                 label="تاریخ دریافت" clearable>
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                <q-date v-model="recordInfo.Cs_SendLinkDateTime" calendar="persian">
                  <div class="row items-center justify-center">
                    <q-btn v-close-popup label="تایید" color="primary" flat/>
                    <q-btn v-close-popup @click="recordInfo.Cs_SendLinkDateTime = ToJalaliDate(new Date())" label="امروز" color="primary"
                           flat/>
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
        <q-field
            filled
            v-model="recordInfo.Cs_Pay"
            mask="currency"
            label="مبلغ دریافتی"
            label-color="indigo"
            autofocus
            dir="ltr"
            lazy-rules
            :rules="[
                val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ دریافتی طرف معامله را وارد نمایید',
                val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ دریاقتی از طرف معامله عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
            ]">
          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
            <input :id="id" class="q-field__native text-right" :value="value"
                   @change="e => emitValue(e.target.value)"
                   v-money="moneyFormatForDirective"
                   v-show="floatingLabel">
          </template>
        </q-field>
        <q-select
            filled
            v-model="selectedBank"
            label="بانک"
            :options="banks"
            option-label="AccName"
            option-value="AccCode"
            use-chips
            use-input
            :rules="[requireRole]"
        >
          <template v-slot:prepend>
            <q-icon name="person"/>
          </template>
        </q-select>

        <q-input
            filled
            autogrow
            v-model="recordInfo.CustomText"
            type="textarea"
            label="شرح مختصر">
        </q-input>
      </q-card-section>
      <q-card-actions align="center">
        <q-btn label="تایید" type="submit" icon="check" color="primary"/>
        <q-btn label="انصراف" type="reset" icon="search_off" color="red" flat class="q-ml-sm" v-close-popup/>
      </q-card-actions>
    </q-card>

  </q-form>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "CustomerReceivePay",
  props: {
    CustomerInfo: {
      type: Object,
    }
  },
  data() {
    return {
      selectedBank: null,
      recordInfo: {
        Cs_Pay: 0,
        CustomText: '',
        Cs_ID: this.CustomerInfo.Cs_ID,
        Cs_SendLinkDateTime: '',
        BankID: 0,
        BankTitle: ''
      },
      banks: [],
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
    }
  },
  methods: {
    ...mapActions({
      receiveCustomerPay: 'Customers/set_customer_pay',
      setBanks: 'Customers/getBanks'
    }),
    onSubmit() {
      this.recordInfo.BankID = this.selectedBank.AccCode
      this.recordInfo.BankTitle = this.selectedBank.AccName
      this.recordInfo.Cs_Pay = parseInt(this.recordInfo.Cs_Pay.replaceAll(',', ''))
      this.receiveCustomerPay(this.recordInfo).then((res) => {
        this.$emit('added-new', res[0])
      })
    },
    requireRole(val) {
      if (val === null || val === undefined || val === '') {
        return 'انتخاب الزامی است'
      }
    },
  },
  created() {
    this.setBanks().then((res) => {
      this.banks = res
    })
  }
}
</script>

<style scoped>

</style>